// **Feedback** — Fehlermeldungen und Wünsche aus allen Mandanten (docs/11 8f).
// Hier das Reine: Wörter, Statusketten, Filter — getestet.

import { ApiError } from "../../api/client";
import { errorText, type Tone } from "../../lib/labels";

export const TYPE: Record<string, [string, Tone]> = { bug: ["Fehler", "error"], feature: ["Wunsch", "info"] };

export const STATUS: Record<string, [string, Tone]> = {
  open: ["Offen", "warn"], triage: ["In Prüfung", "info"], needs_info: ["Rückfrage", "warn"], closed: ["Erledigt", "ok"],
  accepted: ["Angenommen", "ok"], implemented: ["Umgesetzt", "ok"], rejected: ["Abgelehnt", ""],
};

/** Dieselben Ketten wie `feedback-api/src/reports/status.ts` — die API prüft ohnehin. */
export const TRANSITIONS: Record<string, Record<string, string[]>> = {
  bug: { open: ["triage", "needs_info", "closed"], triage: ["needs_info", "closed", "open"], needs_info: ["triage", "closed"], closed: ["triage"] },
  feature: { open: ["triage", "accepted", "rejected"], triage: ["accepted", "rejected", "implemented", "open"], accepted: ["implemented", "triage"], implemented: ["accepted"], rejected: ["triage"] },
};

/** Für diese Status braucht es eine Begründung — sie steht beim Kunden im Verlauf. */
export const NEEDS_NOTE = ["closed", "rejected"];

export const FEEDBACK_ERRORS: Record<string, string> = {
  note_required: "Für „Erledigt“ und „Abgelehnt“ braucht es eine Begründung — sie steht beim Kunden im Verlauf.",
  invalid_transition: "Dieser Statuswechsel ist nicht vorgesehen.",
  feedback_unreachable: "Die Feedback-API antwortet nicht.",
  feedback_not_configured: "Die Feedback-API ist nicht eingerichtet (FEEDBACK_API_URL).",
};

export function feedbackFail(err: unknown): string {
  return (err instanceof ApiError ? FEEDBACK_ERRORS[err.code] : undefined) ?? errorText(err);
}

export function nextStatuses(type: string, status: string): string[] {
  return TRANSITIONS[type]?.[status] ?? [];
}

/** Ein Statuswechsel, der ohne Text nicht geht — `null` heißt: darf. */
export function statusBlocked(status: string, text: string): string | null {
  return NEEDS_NOTE.includes(status) && !text.trim() ? FEEDBACK_ERRORS.note_required ?? null : null;
}

export const DEFAULT_STATUS = "open,triage,needs_info";

export interface FeedbackFilter {
  tenant: string;
  type: string;
  status: string;
}

/**
 * Der Filter aus der Adresse. `status` fehlt → „offen"; `status=` (leer) heißt
 * „alle" und bleibt so — deshalb schreibt die Liste den Status auch leer.
 */
export function filterFromSearch(qs: URLSearchParams): FeedbackFilter {
  return { tenant: qs.get("tenant") ?? "", type: qs.get("type") ?? "", status: qs.get("status") ?? DEFAULT_STATUS };
}

/** Die Abfrage an `/feedback`: nur gesetzte Filter, höchstens 100. */
export function listQuery(f: FeedbackFilter): string {
  const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v));
  q.set("limit", "100");
  return q.toString();
}

export const TYPE_OPTIONS: ReadonlyArray<readonly [string, string]> = [["", "Fehler und Wünsche"], ["bug", "Fehler"], ["feature", "Wünsche"]];
export const STATUS_OPTIONS: ReadonlyArray<readonly [string, string]> = [[DEFAULT_STATUS, "offen"], ["", "alle"], ["closed,accepted,implemented,rejected", "abgeschlossen"]];
